import React from 'react';

import { useCreateDirectChatWithSupport } from '../hooks/useCreateDirectChatWithSupport';

export const CreateConversationWithAdminButton = ({
  children
}: {
  children: React.ReactElement;
}) => {
  const { createConversation } = useCreateDirectChatWithSupport();

  return React.cloneElement(children, {
    onClick: createConversation
  });
};
